var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPopupMessage)?_c('PopupMessage',{attrs:{"title":null,"message":'Are you tax exempt?',"cancel-label":'No',"confirm-label":_vm.isThinking ? '<div class=\'loading\' style=\'margin: 0 auto\'></div>' : 'Yes'},on:{"close":_vm.onClose,"confirm":_vm.onConfirm,"cancel":_vm.onCancel}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }